import { render } from '../../App'
import { connect } from 'react-redux'

import { FepoPro } from './components/FepoPro'

import { reducer } from './reducer'

const mapStateToProps = state => state

const Container =  connect(mapStateToProps, null)(FepoPro)

render(Container, reducer)




